import React from 'react';

const VARIANTS = {
  success: 'ui-badge-success',
  warning: 'ui-badge-warning',
  danger: 'ui-badge-danger',
  info: 'ui-badge-info',
  neutral: 'ui-badge-neutral',
};

export default function Badge({ variant = 'neutral', children, className = '', ...props }) {
  return (
    <span className={`ui-badge ${VARIANTS[variant] || VARIANTS.neutral} ${className}`.trim()} {...props}>
      {children}
    </span>
  );
}
